import styled from 'styled-components'

export const Style = styled.div`
  position: relative;
  display: flex;
  .card {
    background-color: #fff;
    .tag {
      font-family: 'Open Sans';
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ff7400;
      margin-bottom: 40px;
    }
    .title {
      font-family: 'Open Sans';
      margin-bottom: 10px;
      font-size: 30px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #333333;
    }
  }
  .link-apps {
    display: flex;
    width: 100%;
    a {
      margin-top: 10px;
      margin-right: 10px;
      width: 165px;
      > img {
        display: block;
        width: 100%;
      }
    }
    @media screen and (min-width: 320px) and (max-width: 756px) {
      a {
        width: 50%;
      }
    }
  }
  .image {
    width: 100%;
    display: block;
    @media screen and (min-width: 320px) and (max-width: 990px) {
      display: none;
    }
  }
  .end {
    align-items: flex-end;
  }
`
